import type { ObjectId } from '@racemap/sdk/schema/base';
import { RacemapAPIClient } from '@racemap/utilities/api-client';
import { OneMinuteInMillis } from '@racemap/utilities/consts/time';
import type { RacemapEvent } from '@racemap/utilities/types/events';
import useSwr, { type SWRResponse } from 'swr';

const apiClient = RacemapAPIClient.fromWindowLocation();

const fetcher = async (parentEventId: string) =>
  apiClient.getEvents({
    findByParentId: parentEventId,
    show: ['hidden'],
  });

export const useChildEvents = (
  parentEventId: string | ObjectId | null | undefined,
): {
  childs: Array<RacemapEvent>;
  isLoading: boolean;
  error: Error | null;
  mutate: SWRResponse<Array<RacemapEvent>>['mutate'];
} => {
  const { data, isLoading, error, mutate } = useSwr(parentEventId || null, fetcher, {
    revalidateIfStale: false,
    refreshInterval: OneMinuteInMillis,
    revalidateOnFocus: true,
  });

  return { childs: data || [], isLoading, error, mutate };
};
